export default __webpack_public_path__ + "static/media/Harness of Violent Rage.d4b130c9.jpg";